<template>
  <div v-if="isLoad">
    <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    />
    <div class="img-box">
      <div class="img-cell" v-for="(item, index) in imgFaceList" :key="index">
        <van-image
          class="img-cell-l"
          fit="cover"
          :src="item.faceUrl"
          @click="handlePickerImg(item.faceUrl)"
        />
        <van-button
          class="img-cell-r"
          type="default"
          size="small"
          round
          @click="handleDeleteImg(item, index)"
          >删除</van-button
        >
      </div>
    </div>

    <div class="upload-box">
      <div class="upload-box-l" @click="handleUpload">
        <van-image
          class="upload-box-vanImg"
          fit="cover"
          v-if="localId"
          :src="localId"
        />
        <van-image
          class="upload-box-vanImg"
          fit="fill"
          v-else
          :src="borderImgUrl"
        />
        <svg-icon icon-class="add" v-if="!localId" class-name="svg-icon-add" />
      </div>

      <div class="upload-box-m van-multi-ellipsis--l2">
        <svg-icon
          icon-class="info"
          class-name="svg-icon-add"
        />请先点左侧上传再按添加
      </div>
      <van-button
        class="upload-box-r"
        type="info"
        round
        plain
        size="small"
        @click="handleAddImg"
        >添加</van-button
      >
    </div>

    <!-- 调用手机拍照 -->
    <input
      class="handle_none"
      ref="handlePhoto"
      type="file"
      accept="image/*"
      capture="camera"
      @change="changePhoto($event)"
    />
    <!-- 调用手机相册 -->
    <input
      class="handle_none"
      ref="handlePhoneImg"
      type="file"
      accept="image/*"
      @change="changeImg($event)"
    />
    <van-action-sheet
      v-model="menuShow"
      :actions="actions"
      @select="onSelect"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
    />
  </div>
</template>

<script>
import borderImg from "@/assets/u627.png";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      isLoad: false,
      localId: "",
      borderImgUrl: borderImg,
      menuShow: false,
      actions: [{ name: "拍摄" }, { name: "从手机相册选择" }],
      imgFaceList: [],
      shopId: "",
      customerId: "",
    };
  },
  mounted() {
    this.shopId = localStorage.getItem("shopId");
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId") || 0;
    this.isLoad = true;
    this.getFaceImgList();
  },
  methods: {
    handleUpload() {
      if (this.localId != "") {
        return;
      }
      this.menuShow = true;
    },
    onSelect(item) {
      if (item.name == "拍摄") {
        this.$refs.handlePhoto.click();
      } else {
        this.$refs.handlePhoneImg.click();
      }
    },
    onCancel() {
      this.menuShow = false;
    },
    changePhoto(e) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      let formData = new FormData();
      formData.append("shopId", this.shopId);
      formData.append("file", e.target.files[0]);
      this.$authAjax
        .post("/api/wxapp/face/H5/uploadImg", formData)
        .then((res) => {
          console.log(res, "res");
          let { data } = res.data;
          if (res.data.code == 200) {
            this.$toast.clear();
            this.localId = data.imgUrl;
          }
        });
    },
    changeImg(e) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      let formData = new FormData();
      formData.append("shopId", this.shopId);
      formData.append("file", e.target.files[0]);
      this.$authAjax
        .post("/api/wxapp/face/H5/uploadImg", formData)
        .then((res) => {
          let { data } = res.data;
          if (res.data.code == 200) {
            this.$toast.clear();
            this.localId = data.imgUrl;
          }
        });
    },
    //获取人脸列表
    async getFaceImgList() {
      try {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });
        const { data: faceRes } = await this.$authAjax.post(
          "/api/wxapp/face/list",
          {
            customerId: this.customerId,
          }
        );
        if (faceRes.code == 200) {
          this.$toast.clear();
        }
        if (faceRes.data) {
          this.imgFaceList = faceRes.data;
        }
      } catch (err) {
      } finally {
        this.$toast.clear();
      }
    },
    //添加人脸
    handleAddImg() {
      if (this.localId == "") {
        this.$notify({
          type: "danger",
          message: "请先点左侧上传再按添加",
        });
        return;
      }
      this.$toast.loading({
        message: "添加中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let data = {
          shopId: this.shopId,
          customerId: this.customerId,
          faceUrl: this.localId,
        };
        this.$authAjax.post("/api/wxapp/face/cmsCreate", data).then((res) => {
          if (res.data.code != 200) {
            this.$toast.clear();
            this.localId = "";
            this.$notify({ type: "danger", message: res.data.message });
            return;
          }
          this.getFaceImgList();
          this.localId = "";
          this.$toast.clear();
          this.$notify({ type: "success", message: "添加人脸成功！" });
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.$toast.clear()
      }
    },
    //删除人脸
    handleDeleteImg(item, index) {
      this.$toast.loading({
        message: "删除中...",
        forbidClick: true,
        duration: 0,
      });
      let data = {
        faceId: item.faceId,
        customerId: this.customerId,
      };
      this.$authAjax.post("/api/wxapp/face/del", data).then((res) => {
        if (res.data.code != 200) {
          this.$toast.clear();
          this.$notify("删除失败！");
          return;
        }
        this.imgFaceList = this.imgFaceList.splice(0, index);
        this.getFaceImgList();
        this.$toast.clear();
        this.$notify({ type: "success", message: "删除成功！" });
      });
    },
    handlePickerImg(url) {
      ImagePreview([url]);
    },
  },
};
</script>

<style lang="scss" scoped>
.van-nav-bar {
  height: 50px;
  border: 1px solid #ededed;
}
.img-box {
  margin-top: 50px;
  .img-cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 120px;
    border-bottom: 1px solid #ccc;

    .img-cell-l {
      width: 100px;
      height: 100px;
      margin-left: 10px;
    }

    .img-cell-r {
      margin-right: 10px;
    }
  }
}

.upload-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 120px;
  border-bottom: 1px solid #ccc;
  .upload-box-l {
    position: relative;
    width: 100px;
    height: 100px;
    margin-left: 10px;
    .upload-box-vanImg {
      width: 100px;
      height: 100px;
    }
    .svg-icon-add {
      position: absolute;
      width: 30px;
      height: 30px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .upload-box-m {
    font-size: 14px;
    width: 150px;
    text-align: center;
    color: #999;
  }
  .upload-box-r {
    margin-right: 10px;
  }
}
.handle_none {
  display: none;
}
</style>
